import type { DiffableArray } from './types';

/**
 * Implementation of the Longest Common Substring algorithm
 * https://en.wikipedia.org/wiki/Longest_common_substring
 */
export function longestCommonSubsequence<T1, T2>(
    seq1: DiffableArray<T1>,
    seq2: DiffableArray<T2>,
    areEquals: (a: T1, b: T2) => boolean
): { start1: number; start2: number; length: number } {
    const len1 = seq1.length;
    const len2 = seq2.length;

    // Initialize the DP matrix with zeroes
    const dp: number[][] = Array.from({ length: len1 + 1 }, () => Array(len2 + 1).fill(0));

    let maxLength = 0;
    let end1 = 0; // End index in seq1 for the longest common substring
    let end2 = 0; // End index in seq2 for the longest common substring

    // Fill in the DP table
    for (let i = 1; i <= len1; i++) {
        for (let j = 1; j <= len2; j++) {
            const v1 = seq1.at(i - 1);
            const v2 = seq2.at(j - 1);

            if (v1 === undefined || v2 === undefined) {
                throw new Error('Index out of bounds');
            }

            if (areEquals(v1, v2)) {
                // @ts-ignore
                dp[i][j] = dp[i - 1][j - 1] + 1;

                // @ts-ignore
                if (dp[i][j] > maxLength) {
                    // @ts-ignore
                    maxLength = dp[i][j];
                    end1 = i;
                    end2 = j;
                }
            }
        }
    }

    return {
        start1: end1 - maxLength,
        start2: end2 - maxLength,
        length: maxLength,
    };
}
